export default "__VITE_ASSET__22d96cc4__"